import { z } from "zod";

export const terminalKindSchema = z.enum([
  "phase",
  "neutral",
  "earth",
  "control",
  "signal",
]);

export const rotationSchema = z.union([
  z.literal(0),
  z.literal(90),
  z.literal(180),
  z.literal(270),
]);

const id = z.string().min(1);

export const deviceSchema = z.object({
  id: id,
  deviceKind: z.string().min(1),
  designation: z.string().min(1),
  terminals: z.array(id),
  attributes: z.record(z.string(), z.unknown()),
});

export const terminalSchema = z.object({
  id: id,
  deviceId: id,
  kind: terminalKindSchema,
  label: z.string().min(1),
});

export const conductorSchema = z.object({
  id: id,
  fromTerminal: id,
  toTerminal: id,
  attributes: z.object({
    area: z.number().positive().optional(),
    color: z.string().optional(),
    circuit: id.optional(),
  }),
});

export const circuitSchema = z.object({
  id: id,
  designation: z.string().min(1),
  conductors: z.array(id),
});

export const cableSchema = z.object({
  id: id,
  designation: z.string().min(1),
  conductors: z.array(id),
  type: z.string().min(1),
});

export const sheetSchema = z.object({
  id: id,
  index: z.number().int().nonnegative(),
  title: z.string(),
  format: z.enum(["A3", "A4"]),
  orientation: z.enum(["landscape", "portrait"]),
});

export const waypointSchema = z.object({
  x: z.number(),
  y: z.number(),
});

export const deviceOnSheetSchema = z.object({
  deviceId: id,
  sheetId: id,
  x: z.number(),
  y: z.number(),
  rotation: rotationSchema,
});

export const conductorRoutingSchema = z.object({
  conductorId: id,
  sheetId: id,
  waypoints: z.array(waypointSchema),
});

export const referenceMarkSchema = z.object({
  id: id,
  conductorId: id,
  fromSheetId: id,
  toSheetId: id,
  label: z.string(),
});
